// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-disabled[data-v-7c229e4b] {\n  background-color: #F1F5F9 !important;\n}\n[data-v-7c229e4b] .row a {\n  text-decoration: none;\n  cursor: default;\n}\n.scale-enter-active[data-v-7c229e4b],\n.scale-leave-active[data-v-7c229e4b] {\n  transition: all 0.5s ease;\n}\n.scale-enter-from[data-v-7c229e4b],\n.scale-leave-to[data-v-7c229e4b] {\n  opacity: 0;\n  transform: scale(0.9);\n}", ""]);
// Exports
module.exports = exports;
